import React, { Fragment, StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '../../styles/global.scss';
import { GlobalStyleV2 } from '../../styles/global-v2';
import { env } from '../../utils';
import { rgIDs } from '../../../shared/constants/domIDs';
import { SocialProofContainer } from './components/SocialProofContainer';
import { BrandingProvider } from '../../context/BrandingContext';

const domNode = document.getElementById(rgIDs.compactV2);
const DebugMode = env.isDevelopment ? StrictMode : Fragment;

if (domNode) {
  const root = createRoot(domNode);

  root.render(
    <DebugMode>
      <BrandingProvider>
        <SocialProofContainer />
        <GlobalStyleV2 />
      </BrandingProvider>
    </DebugMode>
  );
}
